import type { RouteRecordRaw } from 'vue-router'
import { Roles } from 'src/common/types'

export const settings: RouteRecordRaw = {
  path: 'settings',
  component: () => import('src/pages/admin/Settings.vue'),
  meta: {
    roles: [
      Roles.SuperAdmin,
      Roles.OrgAdmin,
      Roles.CenterAdmin,
      Roles.OfficeStaff,
      Roles.RoomStaff,
    ],
    supportedPlatforms: ['desktop', 'mobile', 'native'],
  },
  children: [
    {
      name: 'admin.settings',
      path: '',
      component: () => import('src/pages/admin/Settings.vue'),
      meta: {
        roles: [
          Roles.SuperAdmin,
          Roles.OrgAdmin,
          Roles.CenterAdmin,
          Roles.OfficeStaff,
          Roles.RoomStaff,
        ],
      },
    },
    {
      name: 'admin.settings.notifications',
      path: 'notifications',
      component: () => import('src/pages/admin/Settings.vue'),
      meta: {
        roles: [
          Roles.SuperAdmin,
          Roles.OrgAdmin,
          Roles.CenterAdmin,
          Roles.OfficeStaff,
          Roles.RoomStaff,
        ],
      },
    },
  ],
}
